import * as React from 'react';
import Cached from 'material-ui/svg-icons/action/cached';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withClassname } from '@components/hoc/withClassname';

import { TasksForm } from '@modules/tasks/TasksForm';
import { ActionBarMyTasks } from '@modules/tasks/TasksGridButtons';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

export const myTasksUrl = '/metropolis/api/ts/tasks/self';
export const myTasksLabel = 'Moje úkoly';
export const myTasksPath = '/tasks/my';
export const MyTasksGrid = compose(
  withRouter,
  setDisplayName('MyTasksGrid'),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: myTasksLabel }]),
  withColumns(Agenda.MY_TASKS),
  withProps<any, any>(({ history, columns }) => ({
    name: 'module-my-tasks',
    url: myTasksUrl,
    Form: TasksForm,
    dialog: false,
    gridProps: {
      ActionBar: ActionBarMyTasks,
      history,
      deleteFiltersTooltip: 'Reset filtrů',
      deleteFiltersIcon: <Cached />,
      columns,
      filterRow: false,
      showCheckboxes: true,
      deleting: false,
      filtering: false,
      locale: 'cz',
      adding: false,
      pageSize: 50,
      version: 2,
      editItem: item => history.push(`/tasks?item=${item.id}`)
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/tasks/MyTasksGrid.tsx